import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import * as api from '../services/api';

const AppContext = createContext();

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within AppProvider');
  }
  return context;
};

export const AppProvider = ({ children }) => {
  const [cabang, setCabang] = useState([]);
  const [pemasukan, setPemasukan] = useState([]);
  const [pengeluaran, setPengeluaran] = useState([]);
  const [inventori, setInventori] = useState([]);
  const [summary, setSummary] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [siteSettings, setSiteSettings] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCabang = useCallback(async () => {
    try {
      const res = await api.getCabang();
      setCabang(res.data);
    } catch (error) {
      console.error('Error fetching cabang:', error);
    }
  }, []);

  const fetchPemasukan = useCallback(async (params = {}) => {
    try {
      const res = await api.getPemasukan(params);
      setPemasukan(res.data);
    } catch (error) {
      console.error('Error fetching pemasukan:', error);
    }
  }, []);

  const fetchPengeluaran = useCallback(async (params = {}) => {
    try {
      const res = await api.getPengeluaran(params);
      setPengeluaran(res.data);
    } catch (error) {
      console.error('Error fetching pengeluaran:', error);
    }
  }, []);

  const fetchInventori = useCallback(async (params = {}) => {
    try {
      const res = await api.getInventori(params);
      setInventori(res.data);
    } catch (error) {
      console.error('Error fetching inventori:', error);
    }
  }, []);

  const fetchSummary = useCallback(async () => {
    try {
      const res = await api.getDashboardSummary();
      setSummary(res.data);
    } catch (error) {
      console.error('Error fetching summary:', error);
    }
  }, []);

  const fetchChartData = useCallback(async () => {
    try {
      const res = await api.getChartData();
      setChartData(res.data);
    } catch (error) {
      console.error('Error fetching chart data:', error);
    }
  }, []);

  const fetchSiteSettings = useCallback(async () => {
    try {
      const res = await api.getSiteSettings();
      setSiteSettings(res.data);
    } catch (error) {
      console.error('Error fetching site settings:', error);
    }
  }, []);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    await Promise.all([
      fetchCabang(),
      fetchPemasukan(),
      fetchPengeluaran(),
      fetchInventori(),
      fetchSummary(),
      fetchChartData(),
      fetchSiteSettings()
    ]);
    setLoading(false);
  }, [fetchCabang, fetchPemasukan, fetchPengeluaran, fetchInventori, fetchSummary, fetchChartData, fetchSiteSettings]);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  const value = {
    cabang,
    pemasukan,
    pengeluaran,
    inventori,
    summary,
    chartData,
    siteSettings,
    loading,
    fetchCabang,
    fetchPemasukan,
    fetchPengeluaran,
    fetchInventori,
    fetchSummary,
    fetchChartData,
    fetchSiteSettings,
    fetchAll
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
